// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-97d4fd","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-dcf6c6","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-65bca3"};